import { DoodMarketplaceModel } from '@core/models/marketplace.model';
import { ContentBuilderVersion } from './content-builder-spec.model';

export function readContentBuilderVersion(
  marketplace:
    | Pick<DoodMarketplaceModel, 'content_builder_version' | 'contentBuilderVersion'>
    | null
    | undefined,
): ContentBuilderVersion {
  const version =
    marketplace?.content_builder_version ??
    (marketplace as { contentBuilderVersion?: string } | undefined)?.contentBuilderVersion;
  return version === 'v2' ? 'v2' : 'legacy';
}

export function isContentBuilderV2Marketplace(
  marketplace:
    | Pick<DoodMarketplaceModel, 'content_builder_version' | 'contentBuilderVersion'>
    | null
    | undefined,
): boolean {
  return readContentBuilderVersion(marketplace) === 'v2';
}
